import consumer from "./consumer"

export const MetricsChannel = (setReload) => {
  return consumer.subscriptions.create({ channel: "MetricsChannel" }, {
    received(_) {
      setReload(Date.now())
    }
  })
}
